"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    clipPath: "url(#prefix__clip0_1054_1708)",
    stroke: "#393939",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, __jsx("path", {
    d: "M58.5 26.25l12 8.25V66a4.5 4.5 0 01-4.5 4.5H6A4.5 4.5 0 011.5 66V34.5l12-8.25"
  }), __jsx("path", {
    d: "M10.5 61.5l15-12h21l15 12M70.5 34.5l-18 12M1.5 34.5l18 12M58.5 42.501V4.5a3 3 0 00-3-3h-39a3 3 0 00-3 3v38.001"
  }), __jsx("path", {
    d: "M47 21.812a11.161 11.161 0 01-11 11.19 10.837 10.837 0 01-11-10.809 11.162 11.162 0 0111-11.192 10.84 10.84 0 0111 10.811zM34 25h4.5"
  }), __jsx("path", {
    d: "M36.501 25v-6.5a.5.5 0 00-.812-.39l-1.688 1.35"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "prefix__clip0_1054_1708"
  }, __jsx("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  }))));
}
var _default = exports.default = SvgComponent;